import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { Box, rem } from '@bonusly/design-system';
import { useBuildMonarchURL } from '@bonusly/url';

import { useIsRecognize } from '../../../hooks/use-is-recognize';

const getStyle = (isActive: boolean) => {
	if (isActive) {
		return {
			bg: 'primary.bgAlpha',
			color: 'primary.fgStrong',
		};
	}

	return {
		bg: 'none',
		color: 'secondary.fg',
		_hover: { bg: 'secondary.bgAlpha' },
	};
};

type UserNavLinkProps = {
	children: ReactNode;
	isExpanded: boolean;
	to: string;
};

export const UserNavLink: FC<UserNavLinkProps> = ({ children, to, isExpanded, ...props }) => {
	const isRecognize = useIsRecognize();
	const monarchURL = useBuildMonarchURL();
	const path = isRecognize ? monarchURL(to) : to;

	return (
		<NavLink to={path} reloadDocument={isRecognize} {...props}>
			{({ isActive }: { isActive: boolean }) => (
				<Box {...getStyle(isActive)} py={rem(8)} px={isExpanded ? rem(10) : rem(8)} borderRadius="md">
					{children}
				</Box>
			)}
		</NavLink>
	);
};
